/**
 * SLABadge — the small pill shown on the top-right of an SLA row.
 * Renders priceType-driven copy like "BEST PRICE" or "FASTER".
 */
import React, { FC } from 'react';
import classNames from 'classnames/bind';
import Text from '../../atoms/Text';
import styles from './index.pcss';

const cx = classNames.bind(styles);

interface SLABadgeProps {
  label?: string;
  fleek?: boolean;
}

const SLABadge: FC<SLABadgeProps> = ({ label = '', fleek = false }) => {
  if (!label) return null;
  return (
    <span className={cx('sla-badge', { 'sla-badge--fleek': fleek })}>
      <Text variant="T1" weight="bold" color={fleek ? 'Nero' : 'White'} removeGrouping ariaHidden>
        {label}
      </Text>
    </span>
  );
};

export default SLABadge;
